<div class="selected-items-visualizer">
  <div mat-dialog-content>
    <h4>{{'se-ui-selector-web_selected_items' | translate}}</h4>
    <se-selected-items-visualizer name="selected-items-visualizer"></se-selected-items-visualizer>
  </div>
</div>
